<script>
    import { link } from 'svelte-spa-router'

    export let id;
    export let ideaImageAbsolutePath;
    export let title;
    export let subtitle;
    export let messageCount = 0;

    let countLabel;

    $: countLabel = messageCount === 1 ? `${messageCount} message` : `${messageCount} messages`;

</script>

<style lang="scss" src="./ChatCard.scss"></style>

<a href={`/idea/${id}?chat`} use:link class="ChatCard">
    <div class="ChatCard__media">
        {#if ideaImageAbsolutePath}
            <img class="ChatCard__image"src={ideaImageAbsolutePath} alt="chat graphic">
        {/if}
    </div>
    <div class="ChatCard__text">
        <span class="ChatCard__title">{title}</span>
        <small class="ChatCard__subtitle">{subtitle || countLabel}</small>
    </div>
</a>